import React from 'react';
import classNames from 'classnames';

import s from './Skeleton.sss';

interface Props {
  type?: 'text' | 'circle' | 'square' | 'rect',
  width?: string,
  height?: string,
  align?: 'left' | 'center' | 'right',
  theme?: 'white' | 'grey',
  style?: React.CSSProperties,
  className?: string,
}

export const Skeleton: React.FC<Props> = ({
  type = 'text',
  width,
  height,
  align = 'left',
  theme = 'grey',
  style,
  className,
}) => (
  <span
    className={
      classNames(className, {
        [s.root]: true,
        [s.themeGrey]: theme === 'grey',
        [s.themeWhite]: theme === 'white',
        [s.typeText]: type === 'text',
        [s.typeCircle]: type === 'circle',
        [s.typeSquare]: type === 'square',
        [s.typeRect]: type === 'rect',
      })
    }
    style={{
      height,
      width,
      marginLeft: ['right', 'center'].includes(align) ? 'auto' : undefined,
      marginRight: ['left', 'center'].includes(align) ? 'auto' : undefined,
      ...style,
    }}
  />
);
